import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-not-found" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "404", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "Страница не найдена", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'PageNotFound',
  setup(__props) {


const goBack = () => {
  window.history.back()
}


return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_v_divider, { class: "my-2" }),
      _hoisted_4
    ]),
    _createVNode(_component_v_btn, {
      color: "primary",
      class: "mt-12 ml-6",
      onClick: goBack
    }, {
      default: _withCtx(() => [
        _createTextVNode("Вернуться назад")
      ]),
      _: 1
    })
  ]))
}
}

})